import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectApiToken,
  selectCompanies,
  selectCompanyDetail,
  selectCount,
  selectError,
  selectIsFormOpen,
  selectIsLoadingUsers,
  selectIsSaving,
  selectMode,
  selectMultiBuyerEntities,
  selectPage,
  selectPageNumbers,
  selectProjectManagers,
  selectSearch,
  selectSelectedUser,
  selectUsers,
  selectUserViewModel,
} from './user.selectors';
import { UserViewModel } from './user-state.model';

@Injectable({ providedIn: 'root' })
export class UserSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly users = this._store.selectSignal(selectUsers);
  public readonly count = this._store.selectSignal(selectCount);
  public readonly page = this._store.selectSignal(selectPage);
  public readonly pageNumbers = this._store.selectSignal(selectPageNumbers);
  public readonly search = this._store.selectSignal(selectSearch);
  public readonly isLoadingUsers =
    this._store.selectSignal(selectIsLoadingUsers);

  public readonly mode = this._store.selectSignal(selectMode);
  public readonly isFormOpen = this._store.selectSignal(selectIsFormOpen);
  public readonly selectedUser = this._store.selectSignal(selectSelectedUser);

  public readonly companies = this._store.selectSignal(selectCompanies);
  public readonly companyDetail = this._store.selectSignal(selectCompanyDetail);
  public readonly multiBuyerEntities = this._store.selectSignal(
    selectMultiBuyerEntities,
  );
  public readonly projectManagers = this._store.selectSignal(
    selectProjectManagers,
  );

  public readonly isSaving = this._store.selectSignal(selectIsSaving);
  public readonly apiToken = this._store.selectSignal(selectApiToken);
  public readonly error = this._store.selectSignal(selectError);

  public readonly viewModel: Signal<UserViewModel> =
    this._store.selectSignal(selectUserViewModel);
}
